<template>
  <div class="space">
    <div class="tab-list">
      <div class="mid">
        <span>专业成效</span>
      </div>
    </div>
    <div class="content">
      <!-- <div class="search">
				<em>
					学年
					<school-year-selector v-model="schoolYear" @change="change"></school-year-selector>
				</em>
				<em>
					学期
					<school-termSelector v-model="schoolTerm" @change="change"></school-termSelector>
				</em>
			</div>-->
      <div class="houor">
        <div class="add-box">
          <el-button
            class="fr"
            type="primary"
            size="small"
            @click="dialogAward = true"
            >新增获奖</el-button
          >
          <el-button
            class="fr"
            type="primary"
            style="margin-right: 10px"
            size="small"
            @click="dialogHonor = true"
            >新增荣誉</el-button
          >
        </div>
        <div>
          <span class="tit">我的荣誉</span>
          <span class="num">{{ teacherHonor.length }}个</span>
        </div>
        <div class="line-box">
          <div class="line" v-for="(i, index) in teacherHonor" :key="i.id">
            <div class="xline"></div>
            <div class="yline" v-if="index + 1 != teacherHonor.length"></div>
            <span class="start">{{ i.awardDate }}</span>
            <span class="end">{{ i.title }}</span>
            <!-- <span class="rank-desc">{{i.ranksDesc}}</span> -->
            <el-button type="text" v-if="i.attach" @click="showPop(i.attach)"
              >附件</el-button
            >
          </div>
        </div>
      </div>
      <div class="houor">
        <div>
          <span class="tit">我的获奖</span>
          <span class="num">{{ teacherAward.length }}个</span>
        </div>
        <div class="line-box">
          <div class="line" v-for="(i, index) in teacherAward" :key="i.id">
            <div class="xline"></div>
            <div class="yline" v-if="index + 1 != teacherAward.length"></div>
            <span class="start">{{ i.awardDate }}</span>
            <span class="end">{{ i.title }}</span>
            <span class="rank-desc">{{ i.ranksDesc }}</span>
            <el-button type="text" v-if="i.attach" @click="showPop(i.attach)"
              >附件</el-button
            >
            <!-- <el-button type="text" @click="editAwardPop(i)">修改</el-button> -->
          </div>
        </div>
      </div>
      <div class="houor">
        <div>
          <span class="tit">我的积分</span>
          <span class="num">{{ allScore }}分</span>
        </div>
        <div class="table-score">
          <div class="score-tab-list">
            <div class="score-flex">
              <span
                @click="tableChange(i.dicCode)"
                :class="activeCode === i.dicCode ? 'active' : ''"
                v-for="i in moduleDicOptions"
                :key="i.dicCode"
                >{{ i.dicName }}</span
              >
            </div>
          </div>
          <el-table
            border
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            :span-method="objectSpanMethod"
            :data="teacherScore"
            stripe
            style="width: 100%"
            :header-cell-style="{ background: '#FFF' }"
          >
            <el-table-column
              v-if="activeCode != 'teaching'"
              prop="actTitle"
              label="活动名称"
            ></el-table-column>
            <el-table-column prop="remark" label="获得积分"></el-table-column>
            <el-table-column prop="createTime" label="时间"></el-table-column>
            <el-table-column prop="score" label="积分"></el-table-column>
          </el-table>
          <pagination
            :pageObj="pageObj"
            @handleSizeChange="handleSizeChange"
            @handleCurrentChange="handleCurrentChange"
          ></pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="附件"
      :visible.sync="isShowPop"
      v-if="isShowPop"
      width="550px"
      center
    >
      <div class="transfer-box">
        <ul>
          <li class="clearfix" v-for="(i, index) in attachList" :key="index">
            <i class="fl big-icon" :class="mapFileIcon(i.attachType)"></i>
            <div class="fl">
              <h1>
                {{
                  i.attachUrl.substring(
                    i.attachUrl.lastIndexOf("\/") + 1,
                    i.attachUrl.length
                  )
                }}
              </h1>
              <h2>{{ i.attachSize }}kb</h2>
            </div>

            <el-button
              type="text"
              class="dow fr"
              @click="
                downloadFile(
                  i.attachUrl,
                  i.attachUrl.substring(
                    i.attachUrl.lastIndexOf('\/') + 1,
                    i.attachUrl.length
                  )
                )
              "
              >下载</el-button
            >
            <el-button
              type="text"
              class="look fr"
              @click="lookFile(i.attachUrl)"
              >查看</el-button
            >
          </li>
        </ul>
      </div>
    </el-dialog>

    <honor-pop
      v-if="dialogHonor"
      :dialog="dialogHonor"
      @changeHonorPop="changeHonorPop"
    ></honor-pop>
    <award-pop
      v-if="dialogAward"
      :dialog="dialogAward"
      :newPropForm="this.selectAward"
      @changeHonorPop="changeAwardPop"
    ></award-pop>
  </div>
</template>

<script>
import AwardPop from "@/components/common/AwardPop.vue";
import HonorPop from "@/components/common/HonorPop.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import schoolYearSelector from "@/components/school/schoolYearSelector.vue";
import schoolTermSelector from "@/components/school/schoolTermSelector.vue";
import { mapGetters } from "vuex";
import dicSelector from "@/components/school/dicSelector.vue";
import AuthorSelector from "@/components/school/authorSelector.vue";
import Pagination from "@/components/Pagination.vue";
import schoolSelector from "@/components/school/schoolSelector.vue";
import uploader from "@/components/school/uploader.vue";
import {
  mapFileIcon,
  mapLinkIcon,
  lookFile,
  downloadUrlFile,
} from "@/utils/index.js";
import { mapState } from "vuex";
export default {
  components: {
    schoolYearSelector,
    schoolTermSelector,
    uploader,
    dicSelector,
    AuthorSelector,
    schoolSelector,
    HonorPop,
    AwardPop,
    Pagination,
  },
  computed: {
    ...mapState(["userInfo", "resOptions"]),
  },
  data() {
    return {
      dialogHonor: false,
      dialogAward: false,
      selectAward: undefined,
      isShowPop: false,
      // schoolYear: 2020,
      // schoolTerm: 1,
      module: "",
      ///
      teacherAward: [],
      teacherHonor: [],
      teacherScore: [],
      attachList: [], //附件
      moduleDicOptions: [],
      allScore: 0,
      activeCode: "",
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    lookFile,
    mapFileIcon,
    changeHonorPop(flag) {
      this.dialogHonor = flag;
      this.init();
    },
    changeAwardPop(flag) {
      this.dialogAward = flag;
      this.init();
    },
    editAwardPop(item) {
      this.selectAward = item;
      this.dialogAward = true;
    },
    init() {
      this.getDic();
      this.getScoreSum();
    },
    getDic() {
      getData("/core/dic/getDictionaryList-page", {
        dicType: "module",
        pageNum: 1,
        pageSize: -1,
      })
        .then((res) => {
          if (res.length > 0) {
            res = res.map((m) => {
              return {
                dicCode: m.dicCode,
                dicName: m.dicName,
              };
            });
            this.moduleDicOptions = res;
            this.activeCode = res[0].dicCode;
            this.selectData();
            this.selectTable();
          } else {
            this.moduleDicOptions = [];
          }
        })
        .catch((e) => {})
        .finally(() => {});
    },
    change() {
      //this.schoolYear && this.schoolTerm && this.selectData();
    },
    async selectData() {
      let { teacherAwardDTOS } = await postJson("/planning/getEffectiveness", {
        // schoolTerm: "",
        // schoolYear: "",
        userId: this.userInfo.userId,
      });
      this.teacherAward = teacherAwardDTOS.filter(
        (i) => i.classify === "award"
      );
      this.teacherHonor = teacherAwardDTOS.filter(
        (i) => i.classify === "honor"
      );
    },
    tableChange(code) {
      this.pageObj.current = 1;
      this.activeCode = code;
      this.selectTable();
    },
    async selectTable() {
      let { records, total } = await postJson("/planning/getMyScoreList", {
        // schoolTerm: "",
        // schoolYear: "",
        module: this.activeCode,
        userId: this.userInfo.userId,
        pageNum: this.pageObj.current,
        pageSize: this.pageObj.size,
      });
      this.teacherScore = records;
      this.pageObj.total = total;
      this.teacherScore.forEach((i) => {
        i.moduleName = this.moduleDicOptions.find(
          (m) => m.dicCode === i.module
        ).dicName;
      });
    },
    getScoreSum() {
      postData("/planning/getScoreSum", {
        userId: this.userInfo.userId,
      }).then((data) => {
        this.allScore = data;
      });
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.current = 1;
      this.pageObj.size = pageSize;
      this.selectTable();
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage;
      this.selectTable();
    },
    showPop(attach) {
      if (attach == "") {
        return;
      } else {
        this.attachList = JSON.parse(attach);
        this.isShowPop = true;
      }
    },
    downloadFile(url, name) {
      //确认下载完成 后 进行下载记录保存
      downloadUrlFile(url, name);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log(
      // 	"row, column, rowIndex, columnIndex",
      // 	row,
      // 	column,
      // 	rowIndex,
      // 	columnIndex
      // );
      // if (columnIndex === 0 || columnIndex === 3 || columnIndex === 4) {
      //   if (this.mergeObj[column.property][rowIndex]) {
      //     return {
      //       rowspan: this.mergeObj[column.property][rowIndex],
      //       colspan: 1,
      //     };
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0,
      //     };
      //   }
      // }
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.space {
  .tab-list {
    background-color: #fff;
    padding: 20px 0px;
    border-bottom: 2px solid #eee;
    span {
      font-size: 17px;
      padding: 6px 8px;
      border-radius: 8px;
      margin-left: 100px;
      color: @color;
    }
  }
  .content {
    background-color: #fff;
    margin-top: 15px;
    padding: 20px 30px;
    .search {
      em {
        margin-right: 25px;
        font-size: 14px;
      }
    }
    .houor {
      margin-top: 25px;
      margin-bottom: 20px;
      .tit {
        font-size: 15px;
        font-weight: 550;
      }
      .num {
        margin-left: 20px;
        font-size: 14px;
        border-radius: 5px;
        padding: 2px 12px;
        background-color: @color;
        color: #fff;
      }
      .line-box {
        margin-top: 10px;
        .line {
          position: relative;
          left: 0px;
          top: 0px;
          height: 40px;
          span {
            font-size: 14.5px;
          }
          .end {
            margin-left: 120px;
            margin-right: 15px;
          }
          .rank-desc {
            border-radius: 5px;
            margin-right: 15px;
            font-size: 13px;
            padding: 2px 5px 3px 5px;
            background-color: #ffac00;
            color: white;
          }
          .xline {
            width: 100px;
            border-bottom: 2px solid rgb(175, 167, 167);
            left: 83px;
            position: absolute;
            top: 19px;
          }
          .yline {
            height: 40px;
            border-left: 2px solid rgb(175, 167, 167);
            left: 83px;
            position: absolute;
            top: 19px;
          }
        }
      }
      .table-score {
        margin-top: 20px;
      }
    }
  }
  /deep/.el-dialog--center {
    border-radius: 15px;
  }
  .transfer-box {
    ul {
      padding-left: 8px;
      // border: 1px solid rgb(241, 237, 237);
      // max-height: 357px;
      min-height: 40px;
      // overflow-y: auto;
      li {
        padding: 8px;
        margin-bottom: 10px;
        border: 1px solid rgb(224, 222, 222);
        border-radius: 5px;
        .big-icon {
          font-size: 35px;
          color: @color;
          // font-weight: 700;
        }
        .divider {
          margin-left: 20px;
          // border: 0.3px solid rgb(226, 220, 220);
          height: 38px;
        }
        h1 {
          font-size: 13px;
          padding-left: 10px;
        }

        h2 {
          margin-top: 2px;
          font-size: 12px;
          padding-left: 10px;
          color: @hui;
        }
        .look {
          margin-right: 60px;
        }
        .dow {
          margin-right: 100px;
        }
        .del {
          margin-right: 60px;
        }
      }
    }
  }
}
.score-tab-list {
  margin-bottom: 15px;
  padding: 10px;
  width: 100%;

  //   overflow: hidden;
  //   overflow-x: auto;
  border-top: 2px solid #eee;
  border-bottom: 2px solid #eee;
  //   border: 1px solid red;
  .score-flex {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
    width: 100%;
  }
  span {
    font-size: 14px;
    // margin-left: 20px;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: 8px;
    font-weight: 700;
    text-align: center;
    // min-width: 100px;
  }
  span:hover {
    color: @color;
    background-color: @hover-bg;
  }
  .active {
    color: @color;
    background-color: @hover-bg;
  }
}
</style>
